import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress the benign Chromium "ResizeObserver loop completed with undelivered
// notifications" warning that React's dev-mode error overlay otherwise blows
// up into a full-screen modal. The message is harmless (browser layout
// engine), and the suppression is scoped strictly to that exact prefix so
// real errors still surface normally.
if (typeof window !== "undefined") {
  window.addEventListener("error", (e) => {
    if (
      typeof e?.message === "string" &&
      e.message.startsWith("ResizeObserver loop")
    ) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
